<template>
    <div :class="{ 'next-background': mode === 'home' }">
        <mainindex>
            <div v-if="!islogmode" class="content">
                <!--<div class="content" v-if="gen._UID && !islogmode">-->
                <!--HEADER-->
                <page-header v-if="mode !== 'home' && mode !== 'startprj'" :menu-tree="menu" :cur-page="mode" @nav="go($event)" @save-prj="savePrj()" @new-prj="newPrj()" @clone-prj="cloneProject()" @openlogspanel="toggleLogsPanel"></page-header>
                <!--HEADER-->
                <!--BODY-->
                <div class="body" :class="[paddingClass]">
                    <router-view v-if="$route.name !== null"></router-view>
                    <div v-else>
                        <template v-if="mode === 'home'">
                            <home @new-prj="newPrj" @load-prj="!user.guest ? go('projects.my') : go('projects.guest')" @nav="go($event)"></home>
                        </template>
                        <template v-else-if="mode === 'startprj'">
                            <start-prj @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'projects.guest' && user.guest">
                            <prj-finder
                                key="CUSTOMER"
                                filter="GUEST"
                                title="My Projects"
                                :rows-number="5"
                                order-by="11D"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.my' && !user.guest">
                            <prj-finder
                                key="MY"
                                filter="MY"
                                title="My Projects"
                                :rows-number="5"
                                order-by="11D"
                                :cols="[
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('reference'), order: 6 },
                                    { id: 'status', title: _trans('status'), order: 4 },
                                    { id: 'lastedit', title: _trans('last edit'), order: 11 },
                                    { id: 'shopdes', title: _trans('shop'), order: 8 },
                                    { id: 'usermail', title: _trans('user'), order: 9 },
                                    { id: 'ownermail', title: _trans('owner'), order: 10 },
                                    { id: 'open', title: null },
                                    { id: 'viewoffer', title: null },
                                    { id: 'order', title: null },
                                    { id: 'download', title: null },
                                    { id: 'production', title: null },
                                    { id: 'delete', title: null },
                                    { id: 'close', title: null }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <prj-finder
                                key="INVOLVED"
                                filter="INVOLVED"
                                title="Involved projects"
                                :rows-number="5"
                                order-by="11D"
                                :cols="[
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'usermail', title: 'user', order: 9 },
                                    { id: 'ownermail', title: 'owner', order: 10 },
                                    { id: 'download', title: null },
                                    { id: 'production', title: null },
                                    { id: 'open', title: null },
                                    { id: 'assign', title: null }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.ext' && !user.guest">
                            <prj-finder
                                key="UNASSIGNED"
                                filter="UNASSIGNED"
                                title="Unassigned Projects"
                                :rows-number="5"
                                order-by="11D"
                                :cols="[
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'open', title: null },
                                    { id: 'assign', title: null }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <prj-finder key="OTHERPRJ" filter="OTHERPRJ" title="Other Projects In My Store" :rows-number="5" order-by="11D" @open="openPrj($event)"></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.clinv' && !user.guest">
                            <prj-finder key="CLOSED" filter="CLOSED" title="Closed Projects" :rows-number="5" order-by="11D" @open="openPrj($event)"></prj-finder>
                            <prj-finder
                                key="INACTIVE"
                                filter="INACTIVE"
                                title="Inactive Projects"
                                :rows-number="5"
                                order-by="11D"
                                :cols="[
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: 'name', order: 6 },
                                    { id: 'status', title: 'status', order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'user', title: 'user', order: 9 }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'notifications'">
                            <notifications></notifications>
                        </template>
                        <template v-else-if="mode === 'itemsearch'">
                            <article-search @nav="go($event)"></article-search>
                        </template>
                        <template v-else-if="mode === 'renders'">
                            <renders @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'configurator'">
                            <configure update-picture @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === '3dview'">
                            <view3d @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === '2dview'">
                            <view2d @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'compositions'" @nav="go($event)">
                            <compositions :apply-header="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'offerview'">
                            <offer @nav="go"></offer>
                        </template>
                        <template v-else-if="mode === 'summary'">
                            <prj-summary />
                        </template>
                        <template v-else-if="mode === 'customerinfo'">
                            <customer-info />
                        </template>
                        <template v-else-if="mode === 'prjlog'">
                            <prj-log />
                        </template>
                        <template v-else-if="mode === 'delivery'">
                            <delivery />
                        </template>
                        <template v-else-if="mode === 'promotions'">
                            <promotions />
                        </template>
                        <template v-else-if="mode === 'json'">
                            <d-json :value="prj" />
                        </template>
                        <template v-else-if="mode === 'myprofile'">
                            <my-profile />
                        </template>
                        <template v-else>
                            <h1>::::{{ mode }}::::</h1>
                        </template>
                    </div>
                </div>
                <!--BODY-->
            </div>
            <home v-else @new-prj="newPrj" @load-prj="go('projects.my')" @nav="go($event)"></home>
        </mainindex>
        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>
    </div>
</template>

<script>
    import "../../../scss/vitrum.scss";
    import index from "@configurator/index";
    import { customImport } from "@/utils";

    export default {
        mixins: [index],
        components: {
            pageHeader: () => customImport("comp/pageHeaderNew.vue")
        },
        data() {
            return {
                menu: require("@assets/next/json/menu.json")
            };
        },
        methods: {
            resetCustomerParams() {
                this.$set(this.prj, "customerFields", {
                    customerCompany: "",
                    percDiscount: 0,
                    prjNote: "",
                    paymentTerms: "",
                    deliveryTiming: ""
                });
            },
            onNewProject() {
                this.go("itemsearch");
            },
            onProjectLoaded() {
                if ("customerCompany" in this.prj.customerFields && "percDiscount" in this.prj.customerFields && "prjNote" in this.prj.customerFields && "paymentTerms" in this.prj.customerFields && "deliveryTiming" in this.prj.customerFields) {
                    this.go("offerview");
                } else {
                    this.$set(this.prj, "customerFields", {
                        customerCompany: "",
                        percDiscount: 0,
                        prjNote: "",
                        paymentTerms: "",
                        deliveryTiming: ""
                    });
                    this.go("offerview");
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .no-menu {
        padding-top: 0;
    }

    .mid-menu {
        padding-top: 90px;
        //padding-top: 2.512rem;
        @include media-breakpoint-down(md) {
        }
    }

    .full-menu {
        padding-top: 131px;
        @include media-breakpoint-down(md) {
            //padding-top: 5.15rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/custom/vitrum/start.vue